import React from 'react';
import './version-update-banner.scss';

// Bandeau non intrusif en bas d'ecran, signale a l'user qu'une nouvelle version
// du front est disponible. Le bouton "Mettre a jour" force un reload, ce qui
// permet au navigateur de servir le nouvel index.html (header no-cache) puis
// les nouveaux bundles (nouveaux hash).
const VersionUpdateBanner = ({onUpdate}) => (
    <div className="version-update-banner alert alert-warning d-flex align-items-center justify-content-between" role="alert">
        <span>A new version of the application is available.</span>
        <div className="d-flex align-items-center">
            <button type="button" className="btn btn-sm btn-warning me-2" onClick={onUpdate}>
                Update
            </button>
            <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={e => e.currentTarget.closest('.version-update-banner').remove()}
            />
        </div>
    </div>
);

export default VersionUpdateBanner;